import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import InputField from "../../../components/ui/InputField";
import { Button } from "../../../components/ui/Button";
import AuthLayout from "../../../layouts/AuthLayout";
import api from "../../../api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("This reset link is missing its token. Please request a new one.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setSubmitting(true);
    try {
      await api.resetPassword(token, newPassword);
      setDone(true);
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to reset password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}

      {done ? (
        <p className="text-center text-secondary-700">
          Password reset successfully. Redirecting you to login...
        </p>
      ) : !token ? (
        <div className="text-center">
          <p className="text-secondary-700 mb-6">
            This reset link is invalid or incomplete.
          </p>
          <Link to="/forgot-password" className="text-sm font-medium text-primary-600 hover:text-primary-700">
            Request a new link
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <InputField
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            data-label="New Password Input"
          />
          <InputField
            label="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            data-label="Confirm New Password Input"
          />
          <Button type="submit" disabled={submitting} className="w-full">
            {submitting ? "Resetting..." : "Reset Password"}
          </Button>
          <div className="text-center mt-4">
            <Link to="/" className="text-sm font-medium text-gray-500 hover:text-gray-700">
              ← Back to Login
            </Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
